import {
    FETCH_SUMMARY_SUCCESS,
    FETCH_FLAGGED_SUMMARY_SUCCESS,
    FETCH_INCOMPLETE_SUCCESS,
    FETCH_EXCEPTIONS_SUCCESS,
    FETCH_REPORT_RANGES_SUCCESS,
    FETCH_SUMMARY_JOBS_SUCCESS,
    FETCH_SUMMARY_ERROR,
    CLEAR_SUMMARY_SUCCESS,
    LOADING_SUMMARY
} from "api/menu/summary/actions";

const initialState = {
    loading: false,
    errors: [],

    summaryList: {},
    summaryJobs: [],
    summaryIncomplete: [],
    summaryExceptions: [],
    summaryRanges: [],
    summaryFlagged: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case LOADING_SUMMARY:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_SUMMARY_ERROR:
            return {
                ...state,
                errors: action.payload
            };
        case FETCH_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                errors: [],
                summaryList: action.payload
            };
        case FETCH_FLAGGED_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                errors: [],
                summaryFlagged: action.payload
            };
        case FETCH_SUMMARY_JOBS_SUCCESS:
            return {
                ...state,
                loading: false,
                summaryList: {},
                summaryJobs: action.payload,
            };
        case FETCH_REPORT_RANGES_SUCCESS:
            return {
                ...state,
                loading: false,
                summaryList: {},
                summaryRanges: action.payload
            };
        case FETCH_INCOMPLETE_SUCCESS:
            return {
                ...state,
                loading: false,
                summaryIncomplete: action.payload
            };
        case FETCH_EXCEPTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                summaryExceptions: action.payload
            };
        case CLEAR_SUMMARY_SUCCESS:
            return {
                loading: false,
                errors: [],
                summaryList: {},
                summaryJobs: [],
                summaryIncomplete: [],
                summaryExceptions: [],
                summaryRanges: []
            };
        default:
            return state;
    }
}
